import { render, staticRenderFns } from "./CustomerMain.vue?vue&type=template&id=df3e2c7c&scoped=true"
import script from "./CustomerMain.vue?vue&type=script&lang=js"
export * from "./CustomerMain.vue?vue&type=script&lang=js"
import style0 from "./CustomerMain.vue?vue&type=style&index=0&id=df3e2c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3e2c7c",
  null
  
)

export default component.exports